import { DefaultModel } from "../../framework/default.model";
import { CfgIntegracaoHttpMethod } from "./cfg-integracao-http-method.enum";

export class CfgIntegracaoEventoCliente extends DefaultModel {

    idCfgIntegracaoEvento: number;

    url: string;

    method: CfgIntegracaoHttpMethod;

    constructor() {
      super();
      this.status = '';
      this.url = '';
      this.method = null;
    }
}